import TumengDraggable from './src/index.vue'

TumengDraggable.install = function(Vue) {
  Vue.component(TumengDraggable.name, TumengDraggable)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengDraggable)
}

export default TumengDraggable
